'use client';

import { CommandPalette } from '@/components/CommandPalette';
import { VoiceCapture } from '@/components/VoiceCapture';
import { FunctionComponent, useEffect, useState } from 'react';

interface SponsorOption {
  id: string;
  name: string;
  plan_name: string;
}

interface Props {
  sponsors: SponsorOption[];
}

export const GlobalShortcuts: FunctionComponent<Props> = ({ sponsors }) => {
  const [paletteOpen, setPaletteOpen] = useState(false);
  const [voiceOpen, setVoiceOpen] = useState(false);

  useEffect(() => {
    function onKey(e: KeyboardEvent): void {
      const mod = e.metaKey || e.ctrlKey;
      if (mod && !e.shiftKey && !e.altKey && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setVoiceOpen(false);
        setPaletteOpen(p => !p);
      } else if (mod && e.shiftKey && !e.altKey && e.key.toLowerCase() === 'm') {
        e.preventDefault();
        setPaletteOpen(false);
        setVoiceOpen(v => !v);
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  useEffect(() => {
    function openPalette(): void {
      setVoiceOpen(false);
      setPaletteOpen(true);
    }
    function openVoice(): void {
      setPaletteOpen(false);
      setVoiceOpen(true);
    }
    window.addEventListener('matilda:open-palette', openPalette);
    window.addEventListener('matilda:open-voice', openVoice);
    return () => {
      window.removeEventListener('matilda:open-palette', openPalette);
      window.removeEventListener('matilda:open-voice', openVoice);
    };
  }, []);

  return (
    <>
      {paletteOpen ? <CommandPalette sponsors={sponsors} onClose={() => setPaletteOpen(false)} /> : null}
      {voiceOpen ? <VoiceCapture onClose={() => setVoiceOpen(false)} /> : null}
    </>
  );
};
